<template>
    <div class="cellLinkType">
        <div v-if="cleanConditions && cleanConditions.length > 0">
            <a href="#" @click.prevent="fnCallback($event)" @click.right.prevent="fnCallback($event,true)">
                <div v-html="getValueFromCondition"></div>
            </a>
        </div>
        <div v-if="!cleanConditions || cleanConditions.length == 0 ">
            <!--<a href="#" @click.middle.stop="fnCallback($event,true)" @click.ctrl.prevent="fnCallback($event,true)" @click.left.prevent="fnCallback($event)" @click.right.stop="fnCallback($event,true)"  >
                <span :class="defaultClass"></span><span> {{ formattedValue }}</span>
            </a>-->
            <a href="#" @click.prevent="fnCallback($event)" @click.right.prevent="fnCallback($event,true)">
                <span :class="defaultClass"></span><span> {{ formattedValue }}</span>
            </a>
        </div>
    </div>
</template>
<script>
    import _ from "lodash";
    import GenericTableService from '@/shared/services/genericConfig/GenericTableService.js';
    import fn from "@/shared/utils/commonFunctions.js";
    /**
     * COMPONENTE DE CELDA DE TABLA PARA MOSTRAR LOS BOTONES
     * SE PUEDE USAR EN LAS TABLAS O EN OTRO SITIO.
     * */
    export default {
        name: "cell-dt-link-type-component",
        data() {
            return {
                defaultClass: 'mdi mdi-link-variant'
            }
        },
        props: ['value', 'paramValue', 'conditionsDict', 'index', 'readTransform', 'format', 'currency', 'area', 'frequency', 'precedent'],
        computed: {
            formattedValue() {
                let formatVal;
                if (this.value && this.readTransform) {
                    formatVal = GenericTableService.getReadTransform(this.value, this.readTransform) || this.value;
                }
                if (this.format) {
                    formatVal = GenericTableService.getFormatAndSuffix(this.currency, this.area, this.frequency, this.precedent, formatVal || this.value, this.format, this.$t("defaultlocale"));
                }
                return formatVal || this.value;
            },
            cleanConditions(){
                return this.conditionsDict.filter(x => x.Value != '')
            },
            getValueFromCondition() {
                var found = false;
                var index = 0;
                // Eval expression
                while (!found && index < this.cleanConditions.length) {
                    found = this.$parent.fnEvalCondition(this.cleanConditions[index].ValueCondition, this.formattedValue, this.index);
                    if (!found) index++;
                }
                // Get value if meet condition
                if (found) {
                    var expression = this.cleanConditions[index].Value.replace(
                        '{{value}}',
                        !fn.isEmpty(this.paramValue) ?
                            this.paramValue :
                            !fn.isEmpty(this.formattedValue) ?
                                this.formattedValue :
                                '');
                    return expression;
                }
            },
        },
        methods: {
            fnCallback: function (e, newTab = false) {
                if (e.ctrlKey) newTab = true;
                this.$emit('btn-click',newTab);
            }
        }
    }

</script>
<style scoped>
    .cellLinkType {
        text-align: center;
    }
</style>
